// angular
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Component, inject, OnInit } from '@angular/core';
// services
import { UserService } from '@shared/services/user.service';
import { LayoutService } from '@app/layout/shared/services/layout.service';
// components
import { TextSummarizerComponent } from '@app/core/components/text-summarizer/text-summarizer.component';
// types & env
import { ProfileMenu } from '@app/layout/shared/types/profile-menu.type';
import { IUser } from '@shared/types/user.type';
import { environment } from '@environments/environment';
// utils & pipes
import { goToExternalUrl } from '@app/shared/utils/goToExternalUrl';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-profile-menu',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    RouterLink,
    TextSummarizerComponent,
    NgClass,
    TranslateDataPipe,
    ImageSourcePipe,
  ],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.scss',
})
export class ProfileMenuComponent implements OnInit {
  public baseUrl: string = environment.baseUrl.base;
  public user!: IUser;
  public currentRoute: string = '';

  public menuInternalRoutes: ProfileMenu[] = [
    {
      id: 0,
      name: 'profileMenu.favorites',
      icon: 'heart',
      route: 'profile/favorites/products',
    },
    {
      id: 1,
      name: 'profileMenu.myComments',
      icon: 'message-dash-2',
      route: 'profile/comments',
    },
  ];

  public menuExternalRoutes: ProfileMenu[] = [
    {
      id: 0,
      name: 'profileMenu.personalInformation',
      icon: 'user-2',
      href: `${environment.baseUrl.panelUrl}/user`,
    },

    {
      id: 1,
      name: 'profileMenu.services',
      icon: 'nut',
      href: `${environment.baseUrl.panelUrl}/services`,
    },
    {
      id: 2,
      name: 'profileMenu.orders',
      icon: 'users',
      href: `${environment.baseUrl.panelUrl}/orders`,
    },
    // {
    //   id: 3,
    //   name: 'profileMenu.businesses',
    //   icon: 'box',
    //   href: `${environment.baseUrl.panelUrl}/businesses`,
    // },
    {
      id: 4,
      name: 'profileMenu.messenger',
      icon: 'more-square',
      href: `${environment.baseUrl.panelUrl}/messenger`,
    },
    {
      id: 5,
      name: 'profileMenu.auctions',
      icon: 'dollar-circle',
      href: `${environment.baseUrl.panelUrl}/auctions`,
    },
    {
      id: 6,
      name: 'profileMenu.tenders',
      icon: 'dollar-square',
      href: `${environment.baseUrl.panelUrl}/tenders`,
    },
    // {
    //   id: 7,
    //   name: 'profileMenu.supportTickets',
    //   icon: 'inbox-notif',
    //   href: `${environment.baseUrl.panelUrl}/tickets`,
    // },
  ];

  // dependencies
  private readonly _userService = inject(UserService);
  private readonly _layoutService = inject(LayoutService);
  private readonly _router = inject(Router);

  constructor() {
    // set current route
    this.currentRoute = this._router.url;
    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.currentRoute = event.url;
      }
    });
  }

  ngOnInit(): void {
    this.getUserData();
  }

  public getUserData() {
    this._userService.user$.subscribe((user: IUser) => {
      if (user.job_position) {
        this.user = {
          ...user,
          job_position: user.job_position,
        };
      }
    });
  }

  public logout() {
    this._userService.logout();
  }

  public openPanel(link?: string) {
    if (link) {
      goToExternalUrl(link);
    }
  }

  public onClickProfileMenuItems() {
    this._layoutService.hiddenProfileMenu.set(true);
    this._layoutService.windowIsOpen.set(false);
  }
}
